var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.15039 7.84995C4.15039 6.01147 4.15039 5.09224 4.72153 4.52109C5.29267 3.94995 6.21191 3.94995 8.05039 3.94995H10.0004C11.8389 3.94995 12.7581 3.94995 13.3292 4.52109C13.9004 5.09224 13.9004 6.01147 13.9004 7.84995V11.1C13.9004 12.9384 13.9004 13.8576 13.3292 14.4288C12.7581 15 11.8389 15 10.0004 15H8.05039C6.21191 15 5.29267 15 4.72153 14.4288C4.15039 13.8576 4.15039 12.9384 4.15039 11.1V7.84995Z",
    stroke: "#1C274C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.1502 12.05C2.07324 12.05 1.2002 11.177 1.2002 10.1V6.2C1.2002 3.74869 1.2002 2.52305 1.96172 1.76152C2.72324 1 3.94889 1 6.4002 1H9.0002C10.0772 1 10.9502 1.87305 10.9502 2.95",
    stroke: "#1C274C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCopy);
export default __webpack_public_path__ + "static/media/fileCopy.f12c5ac43f5afd8a950f35d1541b2a45.svg";
export { ForwardRef as ReactComponent };